import React, { useEffect, useMemo, useState } from "react";
import {
  Typography,
  Container,
  Button,
  CircularProgress,
  Modal,
  Stack,
  debounce,
} from "@mui/material";

import { makeStyles } from "@mui/styles";

import { backend, API_URL } from "../../../config";
import { Link } from "react-router-dom";

import { useSelector } from "react-redux";

import Fees from "../components/UIs/Fees";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

export const CustomerFees = (props) => {
  const classes = useStyles();

  const customerId = props.match.params.id;
  const currentUserStore = useSelector((state) => state.current_user);

  const [customer, setCustomer] = useState({
    id: "",
    name: "",
    company_id: "",
    company_location: [],
    company_location_id: [],
    fees: [],
    margins: [],
    surcharges: [],
  });
  const [customerLoaded, setCustomerLoaded] = useState(false);
  const [customerMapped, setCustomerMapped] = useState(false);

  const [confirmModal, setConfirmModal] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finishedFlag, setFinishedFlag] = useState(false);
  const [feeInfo, setFeeInfo] = useState({
    fee_type: "margin",
    type: "",
    amount: "",
    aprice: "",
    oprice: "",
    description: "",
    company_location: null,
    product: null,
    id: null,
    hidden: false,
    warehouse: "",
    category: null,
    deleted: false,
    modified: false,
    new: true,
  });
  const [feesMethod, setFeesMethod] = useState([]);
  const [feesType, setFeesType] = useState(["margin"]);

  const [marginTemplates, setMarginTemplates] = useState([]);

  const [warehouses, setWarehouses] = useState([]);
  const [flattenedCategories, setFlattenedCategories] = useState([]);
  const [feesBase, setFeesBase] = useState(0); // 0 = location wide, 1 = per product
  const [productsFees, setProductsFees] = useState([]);
  const [productsFeesLoaded, setProductsFeesLoaded] = useState(false);
  const [productsOptions, setProductsOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleChangeFeesBase = (base) => {
    setFeesBase(base);
  };

  const toggleConfirmModal = () => setConfirmModal(!confirmModal);

  const confirmModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to save the customer
          <b>{` ${customer.name}?`}</b>
          <br />
          <br />
          {feeInfo.amount !== "" &&
          (feeInfo.type === "" ||
            (feesBase === 0
              ? feeInfo.warehouse === ""
              : feeInfo.product === null)) ? (
            <div style={{ color: "red" }}>
              <b>Note: </b>You have a fee amount configured but can't be saved,
              please complete the form.
              <br />
              <br />
            </div>
          ) : (
            <></>
          )}
          <div align="right">
            <Button
              onClick={() => toggleConfirmModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendRequest()}
              className={classes.button}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Saving customer information <br />
              This may take some time relative to the number of categories and
              fees configured
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while saving the customer information
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveError()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          Customer information have been successfully saved
          <br />
          <br />
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
              className={classes.button}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const handleBack = () => {
    props.history.push("/customers");
  };

  const resolveRequest = () => {
    setFinishedFlag(false);
    setLoadingFlag(false);

    toggleConfirmModal();

    if (!errorInfo.error) {
      props.history.push("/customers");
    }
  };

  const resolveError = () => {
    setFinishedFlag(false);
    setLoadingFlag(false);
    setErrorInfo({ error: false, message: "" });
    toggleConfirmModal();
  };

  const sendRequest = () => {
    // todo: change logic to wait for all request to be done
    setLoadingFlag(true);

    const marginsDeleted = customer.margins.filter((item) => item.deleted);
    const marginsModified = customer.margins.filter(
      (item) => item.modified && !item.new && !item.deleted,
    );
    let marginsNew = customer.margins.filter(
      (item) => item.id === null && item.new && !item.deleted,
    );

    if (
      feeInfo.type !== "" &&
      feeInfo.amount !== "" &&
      (feesBase === 0 ? feeInfo.warehouse !== "" : feeInfo.product !== null)
    ) {
      const defaultCompanyLocation = customer.id;
      const defaultWarehouse = warehouses.filter((item) =>
        item.name.includes("Restaurant Depot"),
      );

      delete feeInfo.fee_type;

      const feeInfoObj = {
        ...feeInfo,
        company_location: defaultCompanyLocation,
        warehouseId: feeInfo.warehouse === null ? "" : feeInfo.warehouse.id,
        product: feeInfo.product,
      };

      marginsNew = [...marginsNew, feeInfoObj];

      setFeeInfo({
        fee_type: "margin",
        type: "",
        amount: "",
        aprice: "",
        oprice: "",
        description: "",
        company_location: defaultCompanyLocation,
        product: null,
        id: null,
        hidden: false,
        warehouse: defaultWarehouse.length ? defaultWarehouse[0].id : "",
        category: null,
        deleted: false,
        modified: false,
        new: true,
      });
    }

    if (marginsDeleted.length) {
      marginsDeleted.forEach(async (item) => {
        await backend
          .delete(`${API_URL}margintemplates/${item.id}`)
          .then()
          .catch((error) => {
            console.log(error);
          });
      });
    }

    if (marginsModified.length) {
      marginsModified.forEach(async (item) => {
        delete item.deleted;
        delete item.modified;
        delete item.new;

        const marginObj = {
          ...item,
          warehouse: item.warehouseId,
          category: item.category === null ? null : item.category.id,
          product: item.product ? item.product.upc : item.product,
        };
        delete marginObj.warehouseId;

        await backend
          .patch(`${API_URL}margintemplates/${marginObj.id}`, marginObj)
          .then()
          .catch((error) => {
            console.log(error);
          });
      });
    }

    if (marginsNew.length) {
      marginsNew.forEach(async (item) => {
        delete item.deleted;
        delete item.new;
        delete item.modified;

        const marginObj = {
          ...item,
          warehouse: item.product ? null : item.warehouseId,
          category: item.product || !item.category ? null : item.category.id,
          product: item.product ? item.product.upc : item.product,
        };
        delete marginObj.warehouseId;

        await backend
          .post(`${API_URL}margintemplates/`, marginObj)
          .then()
          .catch((error) => {
            console.log(error);
          });
      });
    }

    if (!errorInfo.error) {
      setLoadingFlag(false);
      setFinishedFlag(true);
    }
  };

  const handleChangeCustomerFee =
    (type, idx, evname = null) =>
    (e, v) => {
      let name = null;
      let value = null;

      // todo: we will refactor the ui soon, come up with better logic
      if (["product", "category"].includes(evname)) {
        name = `${type}-${evname}`;
        value = v;
      } else if (evname === null) {
        name = e.target.name.replace("-" + idx, "");
        value = name.includes("transparent")
          ? e.target.checked
          : e.target.value;
      } else {
        name = evname;
        value = e.toISOString();
      }

      const feeType = name.includes("margin") ? "margin" : "surcharge";
      const feeWarehouse = name.includes("warehouse")
        ? warehouses.find((item) => item.id === value)
        : null;

      if (feeType === "margin") {
        setCustomer((prevState) => {
          name = name.replace(feeType + "-", "");

          let customerFees = prevState.margins.map((fee) => {
            if (idx !== fee.id) return fee;

            if (name.includes("product") && value === null) return fee;

            let feeObj = {
              ...fee,
              [name]: value,
              warehouse: feeWarehouse === null ? fee.warehouse : feeWarehouse,
              modified: true,
            };

            if (name.includes("product")) {
              const productObj = feeObj.product;

              if (productObj?.upc) {
                const defaultOPrice = ["Unit", "Unit / Case"].includes(
                  productObj.unit_type,
                )
                  ? productObj.weight_type === "" ||
                    productObj.weight_type === null
                    ? productObj.base_unit_price
                    : productObj.base_unit_price_per_lb
                  : productObj.weight_type === "" ||
                      productObj.weight_type === null
                    ? productObj.base_case_price
                    : productObj.base_case_price_per_lb;

                let aprice = 0;

                if (feeObj.type === "f") {
                  aprice = +defaultOPrice + +feeObj.amount;
                } else {
                  aprice = +defaultOPrice * (1 + +feeObj.amount / 100);
                }

                feeObj.aprice = aprice.toFixed(2);
                feeObj.oprice = defaultOPrice;
              }
            }

            let calcNumber = 0;

            if (["amount", "oprice", "type"].includes(name)) {
              calcNumber = ["", "f"].includes(feeObj.type)
                ? feeObj.oprice + +feeObj.amount
                : feeObj.oprice * (1 + +feeObj.amount / 100);

              feeObj.aprice = calcNumber.toFixed(2);
            } else if (name === "aprice") {
              calcNumber = ["", "f"].includes(feeObj.type)
                ? +feeObj.aprice - feeObj.oprice
                : (+feeObj.aprice / feeObj.oprice) * 100 -
                  (feeObj.aprice >= feeObj ? 0 : 100);

              feeObj.amount = calcNumber.toFixed(2);
            }

            return feeObj;
          });

          customerFees = customerFees.sort((a, b) => {
            let sortVal = 0;

            if (a.warehouseId > b.warehouseId) {
              return 1;
            }
            if (a.warehouseId < b.warehouseId) {
              return -1;
            }

            if (a.category === null && b.category !== null) {
              return -1;
            }

            if (a.category !== null && b.category === null) {
              return 1;
            }

            sortVal =
              a?.category && b?.category
                ? a?.category?.name.localeCompare(b?.category?.name)
                : sortVal;

            return sortVal;
          });

          return { ...prevState, margins: customerFees };
        });
      } else {
        // todo: update surcharges fees code if implemented
        setCustomer((prevState) => {
          name = name.replace(feeType + "-", "");

          let customerFees = prevState.surcharges.map((fee) => {
            if (idx !== fee.id) return fee;
            return {
              ...fee,
              [name]: value,
              warehouse: feeWarehouse === null ? fee.warehouse : feeWarehouse,
              modified: true,
            };
          });

          return { ...prevState, surcharges: customerFees };
        });
      }
    };

  const applyFeeChange = (name, value, checked) => {
    setFeeInfo((prevState) => {
      let feeInfoObj = {
        ...prevState,
        [name]: name.includes("transparent")
          ? checked
          : name.includes("_date")
            ? value.toISOString()
            : value,
      };

      if (name === "product") {
        let defaultOPrice = "";

        if (feeInfoObj.product !== null) {
          const feeProduct = feeInfoObj.product;
          defaultOPrice = ["Unit", "Unit / Case"].includes(feeProduct.unit_type)
            ? feeProduct.weight_type === "" || feeProduct.weight_type === null
              ? feeProduct.base_unit_price
              : feeProduct.base_unit_price_per_lb
            : feeProduct.weight_type === "" || feeProduct.weight_type === null
              ? feeProduct.base_case_price
              : feeProduct.base_case_price_per_lb;
        }

        feeInfoObj.oprice = defaultOPrice;
      }

      let calcNumber = 0;

      if (["amount", "oprice", "type"].includes(name)) {
        calcNumber = ["", "f"].includes(feeInfoObj.type)
          ? +feeInfoObj.oprice + +feeInfoObj.amount
          : +feeInfoObj.oprice * (1 + +feeInfoObj.amount / 100);

        feeInfoObj.aprice = calcNumber.toFixed(2);
      } else if (name === "aprice") {
        calcNumber = ["", "f"].includes(feeInfoObj.type)
          ? +feeInfoObj.aprice - +feeInfoObj.oprice
          : (+feeInfoObj.aprice / +feeInfoObj.oprice) * 100 -
            (feeInfoObj.aprice >= feeInfoObj ? 0 : 100);

        feeInfoObj.amount = calcNumber.toFixed(2);
      }

      return feeInfoObj;
    });
  };

  const handleChangeFee = async (e, v) => {
    let { name, value, checked } = e.target;

    if (["category"].includes(name)) {
      value = v;
    }

    if (name === "product") {
      setIsLoading(true);
      setProductsOptions([]);

      await backend
        .get(
          `${API_URL}products/${v.upc}/pricingformargins?company_location=${customer?.company?.id}`,
        )
        .then(({ data }) => {
          value = data;
          applyFeeChange(name, value, checked);
          setProductsOptions([...productsFees, data]);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setErrorInfo({
            error: true,
            message: JSON.stringify(error.response.data),
          });
          setIsLoading(false);
        });
    } else {
      applyFeeChange(name, value, checked);
    }

    /* setFeeInfo((prevState) => {
      let feeInfoObj = {
        ...prevState,
        [name]: name.includes("transparent")
          ? checked
          : name.includes("_date")
            ? value.toISOString()
            : value,
      };

      if (name === "product") {
        let defaultOPrice = "";

        if (feeInfoObj.product !== null) {
          const feeProduct = feeInfoObj.product;
          defaultOPrice = ["Unit", "Unit / Case"].includes(feeProduct.unit_type)
            ? feeProduct.weight_type === "" || feeProduct.weight_type === null
              ? feeProduct.base_unit_price
              : feeProduct.base_unit_price_per_lb
            : feeProduct.weight_type === "" || feeProduct.weight_type === null
              ? feeProduct.base_case_price
              : feeProduct.base_case_price_per_lb;
        }

        feeInfoObj.oprice = defaultOPrice;
      }

      let calcNumber = 0;

      if (["amount", "oprice", "type"].includes(name)) {
        calcNumber = ["", "f"].includes(feeInfoObj.type)
          ? +feeInfoObj.oprice + +feeInfoObj.amount
          : +feeInfoObj.oprice * (1 + +feeInfoObj.amount / 100);

        feeInfoObj.aprice = calcNumber.toFixed(2);
      } else if (name === "aprice") {
        calcNumber = ["", "f"].includes(feeInfoObj.type)
          ? +feeInfoObj.aprice - +feeInfoObj.oprice
          : (+feeInfoObj.aprice / +feeInfoObj.oprice) * 100 -
            (feeInfoObj.aprice >= feeInfoObj ? 0 : 100);

        feeInfoObj.amount = calcNumber.toFixed(2);
      }

      return feeInfoObj;
    }); */
  };

  const handleClickAddFee = () => {
    const defaultCompanyLocation = customer.id;
    const defaultWarehouse = warehouses.filter((item) =>
      item.name.includes("Restaurant Depot"),
    );
    const feeWarehouse = warehouses.find(
      (item) => item.id === feeInfo.warehouse,
    );

    setCustomer((prevState) => {
      const feeType = feeInfo.fee_type + "s";

      delete feeInfo.fee_type;

      const feeInfoObj = {
        ...feeInfo,
        company_location: defaultCompanyLocation,
        warehouse: feeWarehouse ? feeWarehouse : "",
        warehouseId: feeInfo.warehouse === null ? "" : feeInfo.warehouse,
        product: feeInfo.product,
      };

      const customerFees = [...prevState[feeType], feeInfoObj].sort((a, b) => {
        let sortVal = 0;

        if (a.warehouseId > b.warehouseId) {
          return 1;
        }
        if (a.warehouseId < b.warehouseId) {
          return -1;
        }

        if (a.category === null && b.category !== null) {
          return -1;
        }

        if (a.category !== null && b.category === null) {
          return 1;
        }

        sortVal =
          a?.category && b?.category
            ? a.category.name.localeCompare(b.category.name)
            : sortVal;

        return sortVal;
      });

      return {
        ...prevState,
        [feeType]: customerFees,
      };
    });

    if (feeInfo.product) {
      setProductsFees([...productsFees, feeInfo.product]);
    }

    setFeeInfo({
      fee_type: "margin",
      type: "",
      amount: "",
      aprice: "",
      oprice: "",
      description: "",
      company_location: defaultCompanyLocation,
      product: null,
      id: null,
      hidden: false,
      warehouse: defaultWarehouse.length ? defaultWarehouse[0].id : null,
      category: null,
      deleted: false,
      modified: false,
      new: true,
    });
  };

  const handleClickDeleteFee = (deletedFee) => {
    const [type, feeId] = deletedFee.split("-");

    if (type === "margin") {
      setCustomer((prevState) => {
        const marginsNew = prevState.margins.map((item, index) => {
          if (item.id !== +feeId) return item;
          return { ...item, deleted: true };
        });

        return { ...prevState, margins: marginsNew };
      });
    } else {
      setCustomer((prevState) => {
        const surchargesNew = prevState.surcharges.map((item, index) => {
          if (item.id !== +feeId) return item;
          return { ...item, deleted: true };
        });

        return { ...prevState, surcharges: surchargesNew };
      });
    }
  };

  const handleChangeProductAuto = useMemo(
    () =>
      debounce(async (e, v) => {
        const validQuery = v !== "" && !v.includes("#") && !v.includes("|");

        if (validQuery && v.length >= 3) {
          setIsLoading(true);
          setProductsOptions([]);
          
          const searchParam = `search=${v}`;

          const companyLocationParam = customer?.company?.id
            ? `&company_location=${customer.company.id}`
            : "";

          await backend
            .get(
              `${API_URL}products?no_page=1&${searchParam}${companyLocationParam}`,
            )
            .then(({ data }) => {
              const productsFeesUPCs = productsFees.map((item) => item.upc);
              const dataFiltered = data.filter(
                (item) => !productsFeesUPCs.includes(item.upc),
              );
              setProductsOptions([...productsFees, ...dataFiltered]);
              setIsLoading(false);
            })
            .catch((error) => {
              console.log(error);
              setErrorInfo({
                error: true,
                message: JSON.stringify(error.response.data),
              });
              setIsLoading(false);
            });
        }
      }, 300),
    [customer, productsFees],
  );

  useEffect(() => {
    const flattenCategories = (categories, depth = 0, parentPath = "") => {
      let flattened = [];

      categories.forEach((category) => {
        const fullPath = parentPath
          ? `${parentPath} > ${category.name}`
          : category.name;

        flattened.push({
          id: category.id,
          name: category.name,
          depth,
          fullPath,
          parent_id: category.parent_id || null,
          active: category.active,
        });

        if (category.children && category.children.length > 0) {
          flattened = [
            ...flattened,
            ...flattenCategories(category.children, depth + 1, fullPath),
          ];
        }
      });

      return flattened;
    };

    const feesMethodTypeGet = () => {
      setFeesMethod(["f", "%"]);
    };

    const feesTypeGet = () => {
      // setFeesType(["margin", "surcharge"]);
      setFeesType(["margin"]);
    };

    const marginTemplatesGet = async () => {
      await backend
        .get(`${API_URL}margintemplates?no_page=1`)
        .then(({ data }) => {
          const dataMap = data.map((item) => ({
            ...item,
            warehouseId: item.warehouse === null ? "" : item.warehouse.id,
            deleted: false,
            modified: false,
            new: false,
          }));
          setMarginTemplates(dataMap); // todo: remove dataMap and leave data
        });
    };

    const warehousesGet = async () => {
      await backend.get(`${API_URL}warehouses?no_page=1`).then(({ data }) => {
        const dataMap = data.map((item) => ({ id: item.id, name: item.name }));
        setWarehouses(dataMap);
        const defaultWarehouse = dataMap.filter((item) =>
          item.name.includes("Restaurant Depot"),
        );
        setFeeInfo((prevState) => ({
          ...prevState,
          warehouse: defaultWarehouse.length ? defaultWarehouse[0].id : null,
        }));
      });
    };

    const categoriesGet = async () => {
      await backend
        .get(`${API_URL}productcategories?no_page=1`)
        .then(({ data }) => {
          const flattened = flattenCategories(data);
          setFlattenedCategories(flattened);
        })
        .catch((error) => {
          console.error("Error fetching categories:", error);
        });
    };

    feesMethodTypeGet();
    feesTypeGet();
    marginTemplatesGet();
    warehousesGet();
    categoriesGet();
  }, []);

  useEffect(() => {
    const customerGet = async () => {
      await backend
        .get(`${API_URL}companylocations/${customerId}`)
        .then(({ data }) => {
          // todo: we might need to change this logic if we support multiple locations per company
          const customerMarginTemplates = marginTemplates
            .filter((item) => item.company_location === data.id)
            .map((item) => ({
              ...item,
              hidden: feesBase
                ? item.product === null
                : item.warehouse === null,
            }));

          const customerObj = {
            ...data,
            fees: [],
            margins: customerMarginTemplates,
            surcharges: [],
          };

          setCustomer(customerObj);
          setCustomerLoaded(true);
        });
    };

    if (!isNaN(customerId) && marginTemplates.length && !customerLoaded) {
      customerGet();
    }
  }, [customerId, customerLoaded, feesBase, marginTemplates]);

  useEffect(() => {
    const filterCustomerFees = () => {
      setCustomer((prevState) => {
        const marginsFiltered = prevState.margins.map((item) => ({
          ...item,
          hidden: feesBase ? item.product === null : item.warehouse === null,
        }));

        const surchargesFiltered = prevState.surcharges.map((item) => ({
          ...item,
          hidden: feesBase ? item.product === null : item.warehouse === null,
        }));

        return {
          ...prevState,
          margins: marginsFiltered,
          surcharges: surchargesFiltered,
        };
      });
    };

    filterCustomerFees();
  }, [feesBase]);

  useEffect(() => {
    const mapCustomerProductFees = () => {
      setCustomer((prevState) => {
        const customerMarginsMap = prevState.margins
          .sort((a, b) => {
            let sortVal = 0;

            if (a.warehouseId > b.warehouseId) {
              return 1;
            }
            if (a.warehouseId < b.warehouseId) {
              return -1;
            }

            if (a.category === null && b.category !== null) {
              return -1;
            }

            if (a.category !== null && b.category === null) {
              return 1;
            }

            sortVal =
              a?.category && b?.category
                ? a.category.name.localeCompare(b.category.name)
                : sortVal;

            return sortVal;
          })
          .map((item) => {
            if (item.product === null) return item;

            const productObj = productsFees.find(
              (product) => product.upc === item.product,
            );

            if (!productObj) return item;

            const defaultOPrice = ["Unit", "Unit / Case"].includes(
              productObj.unit_type,
            )
              ? productObj.weight_type === "" || productObj.weight_type === null
                ? productObj.base_unit_price
                : productObj.base_unit_price_per_lb
              : productObj.weight_type === "" || productObj.weight_type === null
                ? productObj.base_case_price
                : productObj.base_case_price_per_lb;

            let aprice = 0;

            if (item.type === "f") {
              aprice = +defaultOPrice + +item.amount;
            } else {
              aprice = +defaultOPrice * (1 + +item.amount / 100);
            }

            return {
              ...item,
              aprice: aprice.toFixed(2),
              oprice: defaultOPrice,
              product: productObj,
            };
          });

        return { ...prevState, margins: customerMarginsMap };
      });
      setCustomerMapped(true);
    };

    const getProductsFees = () => {
      const companyLocationId = customer?.company?.id;
      let itemsUPC = [];

      customer.margins
        .filter((item) => item.product !== null)
        .forEach((item) => itemsUPC.push(item.product));

      const itemsUPCUnique = [...new Set(itemsUPC)];

      let productsArray = [];

      Promise.all(
        itemsUPCUnique.map(async (upc) => {
          return await backend
            .get(
              `${API_URL}products/${upc}/pricingformargins?company_location=${companyLocationId}`,
            )
            .then(({ data }) => {
              productsArray = [...productsArray, data];

              return productsArray;
            })
            .catch((error) => {
              console.log(error);
              setErrorInfo({
                error: true,
                message: JSON.stringify(error.response.data),
              });
            });
        }),
      ).then(() => {
        setProductsFees(productsArray);
        setProductsOptions(productsArray);
        setProductsFeesLoaded(true);
      });
    };

    if (customerLoaded && !customerMapped && !productsFeesLoaded) {
      getProductsFees();
    }

    if (customerLoaded && !customerMapped && productsFeesLoaded) {
      mapCustomerProductFees();
    }
  }, [
    customer,
    customerLoaded,
    customerMapped,
    productsFees,
    productsFeesLoaded,
  ]);

  return (
    <>
      <Container>
        <Modal open={confirmModal} onClose={toggleConfirmModal}>
          {confirmModalContent}
        </Modal>
        {currentUserStore?.is_staff === true && (
          <Stack direction="row" spacing={1} justifyContent="center">
            <Link to={`/customer/${customerId}`}>
              <Button variant="contained" color="inherit">
                <Typography variant="subtitle2" color="black">
                  Customer Location
                </Typography>
              </Button>
            </Link>
            <Link to={`/customer/${customerId}/orderlists`}>
              <Button variant="contained" color="inherit">
                <Typography variant="subtitle2" color="black">
                  Order Guide
                </Typography>
              </Button>
            </Link>
            <Button variant="contained" color="primary">
              <Typography variant="subtitle2" className="text-white">
                Fees
              </Typography>
            </Button>
          </Stack>
        )}
        <br />
        <Typography component="h6" variant="h6">
          {`${customerId ? "Edit" : "Add"} ${customer.name || ""} Fees`}
        </Typography>
        {!customerMapped ? (
          <div align="center">
            <br />
            <CircularProgress />
            <div>
              Loading products <br />
            </div>
            {errorInfo.error ? (
              <>
                <br />
                <br />
                There was an error while saving the customer information
                <br />
                <br />
                <span
                  style={{
                    color: "red",
                    wordBreak: "break-word",
                    maxHeight: 160,
                    overflow: "hidden",
                    display: "inline-block",
                  }}
                >
                  <b>Error:</b>
                  <br />
                  {errorInfo.message}
                </span>
                <div align="right">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => resolveError()}
                  >
                    Continue
                  </Button>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <>
            <Fees
              {...props}
              customer={customer}
              feeInfo={feeInfo}
              feesMethod={feesMethod}
              feesType={feesType}
              warehouses={warehouses}
              categories={flattenedCategories}
              feesBase={feesBase}
              handleChangeCustomerFee={handleChangeCustomerFee}
              handleChangeFee={handleChangeFee}
              handleClickAddFee={handleClickAddFee}
              handleClickDeleteFee={handleClickDeleteFee}
              handleChangeFeesBase={handleChangeFeesBase}
              productsFees={productsFees}
              handleChangeProductAuto={handleChangeProductAuto}
              productsOptions={productsOptions}
              isLoading={isLoading}
            />
            <br />
            <Stack direction="row" spacing={1} justifyContent="right">
              <Button onClick={handleBack}>Cancel</Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => toggleConfirmModal()}
              >
                Save
              </Button>
            </Stack>
          </>
        )}
      </Container>
    </>
  );
};

export default CustomerFees;
